import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import './styles/SocialsHeader.css';

export default function SocialsHeader({ close, type }) {
  const titleByType = {
    thoughts: 'Thoughts',
    ratings: 'Ratings',
    'ask-ai': 'Ask AI',
  };
  const title = titleByType[type] || 'Social';

  return (
    <>
      <div className="artwork-view-socials-header__container element-non-selectable">
        <Text className="artwork-view-socials-header__text font-size-large">
          {title}
        </Text>
                
        <XIcon className='artwork-view-socials-header-XIcon' onClick={close}/>
      </div>
    </>
  );
}
